// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.base-signup3 {
    max-width: 100%;
    height: auto;
    background: #FFF;
    display: flex;
    flex-direction: row;
    margin-top: 0;
    position: relative;
}

.base-signup3 .left-section {
    width: 100%;
    height: auto;
    position: relative;
}

.base-signup3 .back {
    width: 61px;
    height: 61px;
    position: absolute;
    left: 49px;
    top: 39px;
}

.base-signup3 .box {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
    width: 100%;
    padding: 88px; /* Adjust as needed */
    box-sizing: border-box;
    position: static;
}

.base-signup3 .title {
    display: flex;
    width: 100%;
    height: 54px;
    
    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-100, #111);
    font-family: Georgia;
    font-size: 46px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.base-signup3 .desc {
    display: flex;
    width: 100%;
    height: 32px;
    flex-direction: column;
    justify-content: center;
    color: var(--greyscale-greyscale-70, #6D6D6D);
    font-size: 25px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    margin-top: 50px; /* Vertical spacing between title and desc */
}

.base-signup3 .intro {
    width: 100%;
    color: var(--greyscale-greyscale-100, #111);
    font-family: "Fira Sans";
    font-size: 28px;
    font-style: normal;
    font-weight: 400;
    line-height: 32px;
    margin-top: 50px; /* Vertical spacing between desc and intro */
}

.base-signup3 .issues {
    width: 100%;
    height: 100%;
    margin-top: 20px;

}

.base-signup3 .button {
    display: inline-flex;
    padding: 14px 24px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
    margin-top: 30px;
    background-color: #458BEA;
    color: #FFF;
}

/* Media query for responsiveness */
@media (max-width: 1220px) {
    .base-signup3 {
        flex-direction: column;
    }

    .base-signup3 .left-section {
        width: 100%;
        height: auto;
        margin: 0;
    }

    .base-signup3 .box {
        padding: 20px;
        position: static;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Setup3/style.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,WAAW;IACX,aAAa,EAAE,qBAAqB;IACpC,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;;IAEZ,sBAAsB;IACtB,uBAAuB;IACvB,2CAA2C;IAC3C,oBAAoB;IACpB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,6CAA6C;IAC7C,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;IACI,WAAW;IACX,2CAA2C;IAC3C,wBAAwB;IACxB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB,EAAE,4CAA4C;AAClE;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;;AAEpB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,WAAW;AACf;;AAEA,mCAAmC;AACnC;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;IACb;;IAEA;QACI,aAAa;QACb,gBAAgB;IACpB;AACJ","sourcesContent":[".base-signup3 {\n    max-width: 100%;\n    height: auto;\n    background: #FFF;\n    display: flex;\n    flex-direction: row;\n    margin-top: 0;\n    position: relative;\n}\n\n.base-signup3 .left-section {\n    width: 100%;\n    height: auto;\n    position: relative;\n}\n\n.base-signup3 .back {\n    width: 61px;\n    height: 61px;\n    position: absolute;\n    left: 49px;\n    top: 39px;\n}\n\n.base-signup3 .box {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 10px;\n    width: 100%;\n    padding: 88px; /* Adjust as needed */\n    box-sizing: border-box;\n    position: static;\n}\n\n.base-signup3 .title {\n    display: flex;\n    width: 100%;\n    height: 54px;\n    \n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-100, #111);\n    font-family: Georgia;\n    font-size: 46px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n}\n\n.base-signup3 .desc {\n    display: flex;\n    width: 100%;\n    height: 32px;\n    flex-direction: column;\n    justify-content: center;\n    color: var(--greyscale-greyscale-70, #6D6D6D);\n    font-size: 25px;\n    font-style: normal;\n    font-weight: 300;\n    line-height: normal;\n    margin-top: 50px; /* Vertical spacing between title and desc */\n}\n\n.base-signup3 .intro {\n    width: 100%;\n    color: var(--greyscale-greyscale-100, #111);\n    font-family: \"Fira Sans\";\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 32px;\n    margin-top: 50px; /* Vertical spacing between desc and intro */\n}\n\n.base-signup3 .issues {\n    width: 100%;\n    height: 100%;\n    margin-top: 20px;\n\n}\n\n.base-signup3 .button {\n    display: inline-flex;\n    padding: 14px 24px;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 8px;\n    margin-top: 30px;\n    background-color: #458BEA;\n    color: #FFF;\n}\n\n/* Media query for responsiveness */\n@media (max-width: 1220px) {\n    .base-signup3 {\n        flex-direction: column;\n    }\n\n    .base-signup3 .left-section {\n        width: 100%;\n        height: auto;\n        margin: 0;\n    }\n\n    .base-signup3 .box {\n        padding: 20px;\n        position: static;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
